import React from "react";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";

const CommunicationTab = ({ newMessage, setNewMessage, handleSendMessage, recentMessages }) => (
    <div className="space-y-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Send Message</h3>
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                    <textarea
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        rows={4}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Type your message here..."
                    />
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={handleSendMessage}
                        className="inline-flex items-center px-4 py-2 bg-blue-600 border border-transparent rounded-md font-medium text-white hover:bg-blue-700"
                    >
                        <PaperAirplaneIcon className="w-5 h-5 mr-2" />
                        Send Message
                    </button>
                </div>
            </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="text-lg font-medium text-gray-900">Recent Communications</h3>
            </div>
            <div className="divide-y divide-gray-200">
                {recentMessages.map((message) => (
                    <div key={message.employee_id} className="p-6">
                        <div className="flex items-start space-x-4">
                            <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center text-sm font-medium text-gray-700">
                                {message.avatar}
                            </div>
                            <div className="flex-1">
                                <div className="flex items-center space-x-2">
                                    <h4 className="text-sm font-medium text-gray-900">{message.sender}</h4>
                                    <span className="text-xs text-gray-500">{message.timestamp}</span>
                                </div>
                                <p className="text-sm text-gray-600 mt-1">{message.message}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default CommunicationTab;
